import React, { useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import APIHandler from 'config/APIHandler';

import { useSettings } from 'hooks/useSettings';

import { name } from 'settings';

const Diploma = ({ appId = -1, firstName = '', lastName = '' }) => {
  const [diplomaLoaded, setDiplomaLoaded] = useState(false);

  const handleDiplomaLoaded = () => {
    setDiplomaLoaded((prev) => {
      if (!prev) {
        return true;
      }
      return prev;
    });
  };

  const {
    lang: { langFile },
  } = useSettings();

  // eslint-disable-next-line max-len
  const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}&lang=${langFile}_${langFile
    .replace('pt', 'br')
    .replace('ko', 'kr')
    .toUpperCase()}`;
  const subject = encodeURIComponent(`${name} diploma`);
  const body = encodeURIComponent(image);

  return (
    <div id="diploma" className="fancybox-share diploma">
      <img className="diploma__image" name="diploma" src={image} alt="diploma" onLoad={handleDiplomaLoaded} />
      {diplomaLoaded && (
        <div className="buttons__diploma">
          <a
            href={`/print/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${appId}`}
            disabled={!diplomaLoaded}
            className="fancybox-share__button fancybox-share__button--fb"
          >
            <FontAwesomeIcon icon={['fas', 'print']} />
            {i18n.translate('reportCard.print')}
          </a>
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'at']} />
            <span>{i18n.translate('reportCard.email')}</span>
          </a>
          <a
            href={`https://stack.travpromobile.com/download.php?url=${image}&name=diploma.png`}
            download={`${subject}.png`}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'download']} />
            <span>{i18n.translate('reportCard.download')}</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default Diploma;

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};
